import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_BriefPsychosocialAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_BriefPsychosocialAssessment' className='file-pdf-document'>

            <div className='file-template'>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Age:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Address:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtAge" name="txtAge" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtAddress" name="txtAddress" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtCity" name="txtCity" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone (home):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtState" name="txtState" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtZip" name="txtZip" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtPhone" name="txtPhone" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>(work):</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Ext:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Sexual orientation:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWork" name="txtWork" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtExt" name="txtExt" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtSexual" name="txtSexual" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Religious Affiliation:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Next Court Date (If applicable):</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Referral Agency:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtReligious" name="txtReligious" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="date" id="txtCourtDate" name="txtCourtDate" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtReferralAgency" name="txtReferralAgency" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Referral Behaviors:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Form completed by (if someone other than client):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtReferralBehaviors" name="txtReferralBehaviors" className='add-only' /></td>
                        <td className='w-500'>
                            <input type="text" id="txtFormC" name="txtFormC" className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    Grade in School:
                    1  <input type="checkbox" name="chkGrade1" id="chkGrade1" className='add-only' value="1" />  &nbsp;
                    2  <input type="checkbox" name="chkGrade2" id="chkGrade2" className='add-only' value="2" />   &nbsp;
                    3  <input type="checkbox" name="chkGrade3" id="chkGrade3" className='add-only' value="3" />  &nbsp;
                    4  <input type="checkbox" name="chkGrade4" id="chkGrade4" className='add-only' value="4" /> &nbsp;
                    5  <input type="checkbox" name="chkGrade5" id="chkGrade5" className='add-only' value="5" /> &nbsp;
                    6  <input type="checkbox" name="chkGrade6" id="chkGrade6" className='add-only' value="6" /> &nbsp;
                    7  <input type="checkbox" name="chkGrade7" id="chkGrade7" className='add-only' value="7" /> &nbsp;
                    8  <input type="checkbox" name="chkGrade8" id="chkGrade8" className='add-only' value="8" /> &nbsp;
                    9  <input type="checkbox" name="chkGrade9" id="chkGrade9" className='add-only' value="9" /> &nbsp;
                    10  <input type="checkbox" name="chkGrade10" id="chkGrade10" className='add-only' value="10" /> &nbsp;
                    11  <input type="checkbox" name="chkGrade11" id="chkGrade11" className='add-only' value="11" /> &nbsp;
                    12  <input type="checkbox" name="chkGrade12" id="chkGrade12" className='add-only' value="12" />
                </p>
                <p className='w-750'>
                    N/A  <input type="checkbox" name="chkAdult" id="chkAdult" className='add-only' value="Adult" />
                    Adult
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Ethnicity:</span>
                    <input type="checkbox" name="chkEthnicity" id="chkEthnicity" className='add-only' value="African American" /> African-American &nbsp;
                    <input type="checkbox" name="chkEthnicity1" id="chkEthnicity1" className='add-only' value="Asian" /> Asian &nbsp;
                    <input type="checkbox" name="chkEthnicity2" id="chkEthnicity2" className='add-only' value="Caucasian" /> Caucasian &nbsp;
                    <input type="checkbox" name="chkEthnicity3" id="chkEthnicity3" className='add-only' value="Latin American Hispanic" /> Latin American/Hispanic &nbsp;
                    <input type="checkbox" name="chkEthnicity4" id="chkEthnicity4" className='add-only' value="Native American" /> Native American<br /> &nbsp;
                    <input type="checkbox" name="chkEthnicity5" id="chkEthnicity5" className='add-only' value="Other" /> Other:
                    <input type="text" id="txtOther" name="txtOther" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Parents Willingness to Participate:</span>
                    <input type="checkbox" name="chkWillingness" id="chkWillingness" className='add-only' value="Cooperative" /> Cooperative &nbsp;
                    <input type="checkbox" name="chkWillingness1" id="chkWillingness1" className='add-only' value="Enthusiastic" /> Enthusiastic &nbsp;
                    <input type="checkbox" name="chkWillingness2" id="chkWillingness2" className='add-only' value="Minimal" /> Minimal &nbsp;
                    <input type="checkbox" name="chkWillingness3" id="chkWillingness3" className='add-only' value="Resistant" /> Resistant &nbsp;
                    <input type="checkbox" name="chkWillingness4" id="chkWillingness4" className='add-only' value="Unwilling" /> Unwilling
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>1. PRIMARY REASON(S) FOR SEEKING SERVICES</span>
                    <input type="checkbox" name="chkPrimary" id="chkPrimary" className='add-only' value="Anger Management" /> Anger Management &nbsp;
                    <input type="checkbox" name="chkPrimary1" id="chkPrimary1" className='add-only' value="Anxiety" /> Anxiety &nbsp;
                    <input type="checkbox" name="chkPrimary2" id="chkPrimary2" className='add-only' value="Coping Skills" /> Coping Skills &nbsp;
                    <input type="checkbox" name="chkPrimary3" id="chkPrimary3" className='add-only' value="Depression" /> Depression &nbsp;
                    <input type="checkbox" name="chkPrimary4" id="chkPrimary4" className='add-only' value="Eating Disorder" /> Eating Disorder &nbsp;
                    <input type="checkbox" name="chkPrimary5" id="chkPrimary5" className='add-only' value="Fear Phobias" /> Fear/Phobias &nbsp;<br />
                    <input type="checkbox" name="chkPrimary6" id="chkPrimary6" className='add-only' value="Sexual concerns" /> Sexual concerns &nbsp;
                    <input type="checkbox" name="chkPrimary7" id="chkPrimary7" className='add-only' value="Sleeping Problems" /> Sleeping Problems &nbsp;
                    <input type="checkbox" name="chkPrimary8" id="chkPrimary8" className='add-only' value="Addictive Behaviors" /> Addictive Behaviors &nbsp;
                    <input type="checkbox" name="chkPrimary9" id="chkPrimary9" className='add-only' value="Alcohol Drugs" /> Alcohol/Drugs &nbsp;
                    <input type="checkbox" name="chkPrimary10" id="chkPrimary10" className='add-only' value="Hyperactivity" /> Hyperactivity &nbsp;<br />
                    <input type="checkbox" name="chkPrimary11" id="chkPrimary11" className='add-only' value="ADHD" /> ADHD &nbsp;
                    <input type="checkbox" name="chkPrimary12" id="chkPrimary12" className='add-only' value="PTSD" /> PTSD &nbsp;
                    <input type="checkbox" name="chkPrimary13" id="chkPrimary13" className='add-only' value="Oppositional" /> Oppositional &nbsp;
                    <input type="checkbox" name="chkPrimary14" id="chkPrimary14" className='add-only' value="Truancy" /> Truancy&nbsp;
                    <input type="checkbox" name="chkPrimary15" id="chkPrimary15" className='add-only' value="Running Away" /> Running Away &nbsp;
                    <input type="checkbox" name="chkPrimary16" id="chkPrimary16" className='add-only' value="Hallucinations" /> Hallucinations &nbsp;
                    <input type="checkbox" name="chkPrimary17" id="chkPrimary17" className='add-only' value="Sexual Abuse" /> Sexual Abuse &nbsp;<br />
                    <input type="checkbox" name="chkPrimary18" id="chkPrimary18" className='add-only' value="Physical Abuse" /> Physical Abuse &nbsp;
                    <input type="checkbox" name="chkPrimary19" id="chkPrimary19" className='add-only' value="Emotional Abuse" /> Emotional Abuse &nbsp;
                    <input type="checkbox" name="chkPrimary20" id="chkPrimary20" className='add-only' value="Other Mental Health" /> Other Mental Health Concerns (specify):
                    <input type="text" id="txtOtherMental" name="txtOtherMental" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>2. FAMILY HISTORY</span>
                </p>
                <p className='w-750'>
                <input type="checkbox" name="cbamilyHistoryNa" id="cbamilyHistoryNa" className='add-only' value="Na" /> N/A  &nbsp; &nbsp;
                    
                    
                    <input type="checkbox" name="chkAdult1" id="chkAdult1" className='add-only' value="Adult" /> Adult
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Parents:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>With whom does the child live at this time?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtParents" name="txtParents" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtAddressWith" name="txtAddressWith" className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Are parents divorced or separated?</span>
                     &nbsp; <input type="radio" id="rbDivorced_Yes" name="rbDivorced" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbDivorced_No" name="rbDivorced" className='add-only' value="0" />  No &nbsp;
                     &nbsp; <input type="radio" id="rbDivorced_Never" name="rbDivorced" className='add-only' value="2" />  Never Married
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Issues surrounding the divorce:</span>
                     &nbsp; <input type="radio" id="rbIssues_Yes" name="rbIssues" className='add-only' value="1" /> Step-parent
                     &nbsp; <input type="radio" id="rbIssues_No" name="rbIssues" className='add-only' value="0" /> Siblings
                     &nbsp; <input type="radio" id="rbIssues_Never" name="rbIssues" className='add-only' value="2" />  Abandonment
                     &nbsp; <input type="radio" id="rbIssues_Living" name="rbIssues" className='add-only' value="3" /> Living Arrangements
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Foster Placement:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Number of Placements:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                             &nbsp; <input type="radio" id="rbFoster_Yes" name="rbFoster" className='add-only' value="1" />  Yes &nbsp;
                             &nbsp; <input type="radio" id="rbFoster_No" name="rbFoster" className='add-only' value="0" />  No &nbsp;
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtPlacements" name="txtPlacements" className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>Client's Mother:</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Age:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtNameClient" name="txtNameClient" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtClientAge" name="txtClientAge" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Where employed:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Work phone:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtEmployed" name="txtEmployed" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtWorkPhone" name="txtWorkPhone" className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Employed:</span>
                     &nbsp; <input type="radio" id="rbEmployed_Yes" name="rbEmployed" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbEmployed_No" name="rbEmployed" className='add-only' value="0" />  No &nbsp;
                     &nbsp; <input type="radio" id="rbEmployed_Never" name="rbEmployed" className='add-only' value="2" />  FT
                     &nbsp; <input type="radio" id="rbEmployed_Living" name="rbEmployed" className='add-only' value="3" /> PT
                </p>
                <p className='w-750'>
                     &nbsp; <input type="radio" id="rbEmployed1_Yes" name="rbEmployed1" className='add-only' value="1" /> Natural parent
                     &nbsp; <input type="radio" id="rbEmployed1_No" name="rbEmployed1" className='add-only' value="0" /> Step-parent
                     &nbsp; <input type="radio" id="rbEmployed1_Never" name="rbEmployed1" className='add-only' value="2" />  Adoptive parent
                     &nbsp; <input type="radio" id="rbEmployed1_Living" name="rbEmployed1" className='add-only' value="3" /> Foster home
                     &nbsp; <input type="radio" id="rbEmployed1_Foster" name="rbEmployed1" className='add-only' value="4" />Other:
                    <input type="text" id="txtOtherFoster" name="txtOtherFoster" className='add-only' />
                </p>
                <p className='w-750'>
                    <strong>Client's Father:</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Age:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtNameClient1" name="txtNameClient1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtClientAge1" name="txtClientAge1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Where employed:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Work phone:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtEmployed1" name="txtEmployed1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtWorkPhone1" name="txtWorkPhone1" className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Employed:</span>
                     &nbsp; <input type="radio" id="rbEmployed2_Yes" name="rbEmployed2" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbEmployed2_No" name="rbEmployed2" className='add-only' value="0" />  No &nbsp;
                     &nbsp; <input type="radio" id="rbEmployed2_Never" name="rbEmployed2" className='add-only' value="2" />  FT
                     &nbsp; <input type="radio" id="rbEmployed2_Living" name="rbEmployed2" className='add-only' value="3" /> PT
                </p>
                <p className='w-750'>
                     &nbsp; <input type="radio" id="rbEmployed3_Yes" name="rbEmployed3" className='add-only' value="1" /> Natural parent
                     &nbsp; <input type="radio" id="rbEmployed3_No" name="rbEmployed3" className='add-only' value="0" /> Step-parent
                     &nbsp; <input type="radio" id="rbEmployed3_Never" name="rbEmployed3" className='add-only' value="2" />  Adoptive parent
                     &nbsp; <input type="radio" id="rbEmployed3_Living" name="rbEmployed3" className='add-only' value="3" /> Foster home
                     &nbsp; <input type="radio" id="rbEmployed3_Foster" name="rbEmployed3" className='add-only' value="4" />Other:
                    <input type="text" id="txtOtherFoster1" name="txtOtherFoster1" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Client Employed:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Does the client want to work?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                             &nbsp; <input type="radio" id="rbEmployed4_Yes" name="rbEmployed4" className='add-only' value="1" />  Yes &nbsp;
                             &nbsp; <input type="radio" id="rbEmployed4_No" name="rbEmployed4" className='add-only' value="0" />  No &nbsp;
                             &nbsp; <input type="radio" id="rbEmployed4_Never" name="rbEmployed4" className='add-only' value="2" />  FT
                             &nbsp; <input type="radio" id="rbEmployed4_Living" name="rbEmployed4" className='add-only' value="3" /> PT
                        </td>
                        <td className='w-375'>
                             &nbsp; <input type="radio" id="rbEmployed5_Yes" name="rbEmployed5" className='add-only' value="1" />  Yes &nbsp;
                             &nbsp; <input type="radio" id="rbEmployed5_No" name="rbEmployed5" className='add-only' value="0" />  No &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>History of Trauma:</span>
                     &nbsp; <input type="radio" id="rbTrauma_1" name="rbTrauma" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbTrauma_0" name="rbTrauma" className='add-only' value="0" />  No &nbsp;, If yes, mark one of the following:
                     <br/>
                     <br/>
                     &nbsp; <input type="radio" id="rbTrauma_2" name="rbTrauma" className='add-only' value="2" />  Seeing somebody shot or stabbed
                     &nbsp; <input type="radio" id="rbTrauma_3" name="rbTrauma" className='add-only' value="3" /> Death of family member
                     &nbsp; <input type="radio" id="rbTrauma_4" name="rbTrauma" className='add-only' value="4" /> Adoption
                     &nbsp; <input type="radio" id="rbTrauma_5" name="rbTrauma" className='add-only' value="5" /> Divorce
                     &nbsp; <input type="radio" id="rbTrauma_6" name="rbTrauma" className='add-only' value="6" /> Victim of rape<br />
                     &nbsp; <input type="radio" id="rbTrauma_7" name="rbTrauma" className='add-only' value="7" /> Witness of rape
                     &nbsp; <input type="radio" id="rbTrauma_8" name="rbTrauma" className='add-only' value="8" /> Family violence
                     &nbsp; <input type="radio" id="rbTrauma_9" name="rbTrauma" className='add-only' value="9" /> Natural disaster
                     &nbsp; <input type="radio" id="rbTrauma_10" name="rbTrauma" className='add-only' value="10" /> Living with alcoholic or drug addict<br />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>History of Abuse</span>
                     &nbsp; <input type="radio" id="rbAbuse_1" name="rbAbuse" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbAbuse_0" name="rbAbuse" className='add-only' value="0" />  No &nbsp; If yes, by whom was client abused:
                    <input type="text" id="txtOtherAbuse" name="txtOtherAbuse" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Type of abuse:</span>
                     &nbsp; <input type="radio" id="rbType_1" name="rbType" className='add-only' value="1" /> Physical
                     &nbsp; <input type="radio" id="rbType_0" name="rbType" className='add-only' value="0" /> Sexual
                     &nbsp; <input type="radio" id="rbType_2" name="rbType" className='add-only' value="2" />  Emotional
                     &nbsp; <input type="radio" id="rbType_3" name="rbType" className='add-only' value="3" /> Psychological
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client is:</span>
                     &nbsp; <input type="radio" id="rbClient_1" name="rbClient" className='add-only' value="1" /> Perpetrator
                     &nbsp; <input type="radio" id="rbClient_0" name="rbClient" className='add-only' value="0" /> Witness
                     &nbsp; <input type="radio" id="rbClient_2" name="rbClient" className='add-only' value="2" />  Victim
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Clinical notes:</span>
                    <textarea id="txtClinical" name="txtClinical" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Client's siblings who live in the household:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Quality of relationship with the client</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Names of Siblings</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Age</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Gender</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>&nbsp;</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtSiblings" name="txtSiblings" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOtherAge" name="txtOtherAge" className='add-only' />
                        </td>
                        <td className='w-100'>
                             &nbsp; <input type="radio" id="rbGender_Yes" name="rbGender" className='add-only' value="1" /> F
                             &nbsp; <input type="radio" id="rbGender_No" name="rbGender" className='add-only' value="0" /> M
                        </td>
                        <td className='w-250'>
                             &nbsp; <input type="radio" id="rbQuality_Yes" name="rbQuality" className='add-only' value="1" /> poor
                             &nbsp; <input type="radio" id="rbQuality_No" name="rbQuality" className='add-only' value="0" /> average
                             &nbsp; <input type="radio" id="rbQuality_Na" name="rbQuality" className='add-only' value="2" />  good
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtSiblings2" name="txtSiblings2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOtherAge2" name="txtOtherAge2" className='add-only' />
                        </td>
                        <td className='w-100'>
                             &nbsp; <input type="radio" id="rbGender2_Yes" name="rbGender2" className='add-only' value="1" /> F
                             &nbsp; <input type="radio" id="rbGender2_No" name="rbGender2" className='add-only' value="0" /> M
                        </td>
                        <td className='w-250'>
                             &nbsp; <input type="radio" id="rbQuality2_Yes" name="rbQuality2" className='add-only' value="1" /> poor
                             &nbsp; <input type="radio" id="rbQuality2_No" name="rbQuality2" className='add-only' value="0" /> average
                             &nbsp; <input type="radio" id="rbQuality2_Na" name="rbQuality2" className='add-only' value="2" />  good
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtSiblings3" name="txtSiblings3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOtherAge3" name="txtOtherAge3" className='add-only' />
                        </td>
                        <td className='w-100'>
                             &nbsp; <input type="radio" id="rbGender3_Yes" name="rbGender3" className='add-only' value="1" /> F
                             &nbsp; <input type="radio" id="rbGender3_No" name="rbGender3" className='add-only' value="0" /> M
                        </td>
                        <td className='w-250'>
                             &nbsp; <input type="radio" id="rbQuality3_Yes" name="rbQuality3" className='add-only' value="1" /> poor
                             &nbsp; <input type="radio" id="rbQuality3_No" name="rbQuality3" className='add-only' value="0" /> average
                             &nbsp; <input type="radio" id="rbQuality3_Na" name="rbQuality3" className='add-only' value="2" />  good
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtSiblings4" name="txtSiblings4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOtherAge4" name="txtOtherAge4" className='add-only' />
                        </td>
                        <td className='w-100'>
                             &nbsp; <input type="radio" id="rbGender4_Yes" name="rbGender4" className='add-only' value="1" /> F
                             &nbsp; <input type="radio" id="rbGender4_No" name="rbGender4" className='add-only' value="0" /> M
                        </td>
                        <td className='w-250'>
                             &nbsp; <input type="radio" id="rbQuality4_Yes" name="rbQuality4" className='add-only' value="1" /> poor
                             &nbsp; <input type="radio" id="rbQuality4_No" name="rbQuality4" className='add-only' value="0" /> average
                             &nbsp; <input type="radio" id="rbQuality4_Na" name="rbQuality4" className='add-only' value="2" />  good
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Others living in household:</span>
                    <textarea id="txtOthersLiving" name="txtOthersLiving" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Total number of people living in the home:</span>
                    <textarea id="txtTotalNumber" name="txtTotalNumber" className='add-only'></textarea>
                </p>
                <h3>3. FAMILY HEALTH HISTORY
                </h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Care Physician:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Telephone:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtPrimaryCare" name="txtPrimaryCare" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtTelephone" name="txtTelephone" className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    Have any of the following diseases occurred among the child's blood relatives and the client? (client, parents, siblings, aunts, uncles or grandparents)
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Check those that apply: C~ Client. F ~ Family</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'><strong>C F</strong></td>
                        <td className='w-250'><strong>C F</strong></td>
                        <td className='w-250'><strong>C F</strong></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAllergies" id="chkAllergies" className='add-only' value="Allergies" />
                            <input type="checkbox" name="chkAllergies1" id="chkAllergies1" className='add-only' value="Allergies1" /> Allergies
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDeafness" id="chkDeafness" className='add-only' value="Deafness" />
                            <input type="checkbox" name="chkDeafness1" id="chkDeafness1" className='add-only' value="Deafness1" /> Deafness
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMuscularDystrophy" id="chkMuscularDystrophy" className='add-only' value="Muscular Dystrophy" />
                            <input type="checkbox" name="chkMuscularDystrophy1" id="chkMuscularDystrophy1" className='add-only' value="Muscular" /> Muscular Dystrophy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkBlindness" id="chkBlindness" className='add-only' value="Blindness" />
                            <input type="checkbox" name="chkBlindness1" id="Blindness1" className='add-only' value="Blindness1" /> Blindness
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAnemia" id="chkAnemia" className='add-only' value="Anemia" />
                            <input type="checkbox" name="chkAnemia1" id="chkAnemia1" className='add-only' value="Deafness1" /> Anemia
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDiabetes" id="chkDiabetes" className='add-only' value="Diabetes" />
                            <input type="checkbox" name="chkDiabetes1" id="chkDiabetes1" className='add-only' value="Diabetes" /> Diabetes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkNervousness" id="chkNervousness" className='add-only' value="Nervousness" />
                            <input type="checkbox" name="chkNervousness1" id="chkNervousness1" className='add-only' value="Nervousness1" /> Nervousness
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCancer" id="chkCancer" className='add-only' value="Cancer" />
                            <input type="checkbox" name="chkCancer1" id="chkCancer1" className='add-only' value="Cancer1" /> Cancer
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAsthma" id="chkAsthma" className='add-only' value="Asthma" />
                            <input type="checkbox" name="chkAsthma1" id="chkAsthma1" className='add-only' value="Asthma1" /> Asthma
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkGlandular" id="chkGlandular" className='add-only' value="Glandular problems" />
                            <input type="checkbox" name="chkGlandular1" id="chkGlandular1" className='add-only' value="Glandular problems1" /> Glandular problems
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPerceptual" id="chkPerceptual" className='add-only' value="Perceptual" />
                            <input type="checkbox" name="chkPerceptual1" id="chkPerceptual1" className='add-only' value="Perceptual1" /> Perceptual motor disorder
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCleft" id="chkCleft" className='add-only' value="Cleft lips" />
                            <input type="checkbox" name="chkCleft1" id="chkCleft1" className='add-only' value="Cleft lips1" /> Cleft lips
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkBleeding" id="chkBleeding" className='add-only' value="Bleeding tendency" />
                            <input type="checkbox" name="chkBleeding1" id="chkBleeding1" className='add-only' value="Bleeding tendency1" /> Bleeding tendency
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkHeart" id="chkHeart" className='add-only' value="Heart diseases" />
                            <input type="checkbox" name="chkHeart1" id="chkHeart1" className='add-only' value="Heart diseases1" /> Heart diseases
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRetardation" id="chkRetardation" className='add-only' value="Mental Retardation" />
                            <input type="checkbox" name="chkRetardation1" id="chkRetardation1" className='add-only' value="Mental Retardation1" /> Mental Retardation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSuicide" id="chkSuicide" className='add-only' value="Suicide" />
                            <input type="checkbox" name="chkSuicide1" id="chkSuicide1" className='add-only' value="Suicide1" /> Suicide
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMultiple" id="chkMultiple" className='add-only' value="Multiple sclerosis" />
                            <input type="checkbox" name="chkMultiple1" id="chkMultiple1" className='add-only' value="Multiple sclerosis1" /> Multiple sclerosis
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkHigh" id="chkHigh" className='add-only' value="High blood pressure" />
                            <input type="checkbox" name="chkHigh1" id="chkHigh1" className='add-only' value="High blood pressure1" /> High blood pressure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSeizures" id="chkSeizures" className='add-only' value="Seizures" />
                            <input type="checkbox" name="chkSeizures1" id="chkSeizures1" className='add-only' value="Seizures1" /> Seizures
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMigraines" id="chkMigraines" className='add-only' value="Migraines" />
                            <input type="checkbox" name="chkMigraines1" id="chkMigraines1" className='add-only' value="Migraines1" /> Migraines
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCerebral" id="chkCerebral" className='add-only' value="Cerebral Palsy" />
                            <input type="checkbox" name="chkCerebral1" id="chkCerebral1" className='add-only' value="Cerebral Palsy1" /> Cerebral Palsy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkKidney" id="chkKidney" className='add-only' value="Kidney disease" />
                            <input type="checkbox" name="chkKidney1" id="chkKidney1" className='add-only' value="Kidney disease1" /> Kidney disease
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSpinal" id="chkSpinal" className='add-only' value="Spinal Bifida" />
                            <input type="checkbox" name="chkSpinal1" id="chkSpinal1" className='add-only' value="Spinal Bifida1" /> Spinal Bifida
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMh" id="chkMh" className='add-only' value="MH" />
                            <input type="checkbox" name="chkMh1" id="chkMh1" className='add-only' value="MH1" /> MH
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSickle" id="chkSickle" className='add-only' value="Sickle Cell" />
                            <input type="checkbox" name="chkSickle1" id="chkSickle1" className='add-only' value="Sickle Cell1" /> Sickle Cell
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCleftPalate" id="chkCleftPalate" className='add-only' value="Cleft palate" />
                            <input type="checkbox" name="chkCleftPalate1" id="chkCleftPalate1" className='add-only' value="Cleft palate1" /> Cleft palate
                        </td>
                        <td className='w-250'>&nbsp; </td>
                    </tr>
                </table>




                <p className='w-750'>
                    Other (specify):<input type="text" id="txtSpecify" name="txtSpecify" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comments re: Family Health</span>
                    <textarea id="txtCommentsFamily" name="txtCommentsFamily" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comments Re: Client Health</span>
                    <textarea id="txtCommentsClient" name="txtCommentsClient" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have any of the following disabilities?</span>
                    <input type="checkbox" name="chkDisabilities" id="chkDisabilities" className='add-only' value="Developmental" /> Developmental &nbsp;
                    <input type="checkbox" name="chkDisabilities1" id="chkDisabilities1" className='add-only' value="Communication disability" /> Communication disability &nbsp;
                    <input type="checkbox" name="chkDisabilities2" id="chkDisabilities2" className='add-only' value="Learning disability" /> Learning disability &nbsp; 
                    <input type="checkbox" name="chkDisabilities3" id="chkDisabilities3" className='add-only' value="Blindness" /> Blindness &nbsp; <br /> 
                    <input type="checkbox" name="chkDisabilities4" id="chkDisabilities4" className='add-only' value="Stuttering" /> Stuttering &nbsp;
                    <input type="checkbox" name="chkDisabilities5" id="chkDisabilities5" className='add-only' value="Physical disability" /> Physical disability &nbsp;
                    <input type="checkbox" name="chkDisabilities6" id="chkDisabilities6" className='add-only' value="Cerebral Palsy" /> Cerebral Palsy &nbsp;
                    <input type="checkbox" name="chkDisabilities7" id="chkDisabilities7" className='add-only' value="Deafness" /> Deafness &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4. MEDICATIONS</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <strong>Current prescribed medications</strong>
                        </td>
                        <td className='w-150'>
                            <strong>Dose</strong>
                        </td>
                        <td className='w-250'>
                            <strong>Dates</strong>
                        </td>
                        <td className='w-100'>
                            <strong>Positive Effect</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtCurrent" name="txtCurrent" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDose" name="txtDose" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtHomeAddressDates" name="txtHomeAddressDates" className='add-only' />
                        </td>
                        <td className='w-100'>
                             &nbsp; <input type="radio" id="rbPositive_Yes" name="rbPositive" className='add-only' value="1" />  Yes &nbsp;
                             &nbsp; <input type="radio" id="rbPositive_No" name="rbPositive" className='add-only' value="0" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtCurrent1" name="txtCurrent1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDose1" name="txtDose1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtHomeAddressDates1" name="txtHomeAddressDates1" className='add-only' />
                        </td>
                        <td className='w-100'>
                             &nbsp; <input type="radio" id="rbPositive1_Yes" name="rbPositive1" className='add-only' value="1" />  Yes &nbsp;
                             &nbsp; <input type="radio" id="rbPositive1_No" name="rbPositive1" className='add-only' value="0" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtCurrent2" name="txtCurrent2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDose2" name="txtDose2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtHomeAddressDates2" name="txtHomeAddressDates2" className='add-only' />
                        </td>
                        <td className='w-100'>
                             &nbsp; <input type="radio" id="rbPositive2_Yes" name="rbPositive2" className='add-only' value="1" />  Yes &nbsp;
                             &nbsp; <input type="radio" id="rbPositive2_No" name="rbPositive2" className='add-only' value="0" />  No &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Is client allergic to any medication?</span>
                     &nbsp; <input type="radio" id="rbAllergic_Yes" name="rbAllergic" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbAllergic_No" name="rbAllergic" className='add-only' value="0" />  No &nbsp;
                </p>
                <p className='w-750'>
                    lf Yes to What:<input type="text" id="txtAllergic" name="txtAllergic" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is client allergic to anything else?</span>
                     &nbsp; <input type="radio" id="rbAllergic1_Yes" name="rbAllergic1" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbAllergic1_No" name="rbAllergic1" className='add-only' value="0" />  No &nbsp;
                </p>
                <p className='w-750'>
                    lf Yes to What:<input type="text" id="txtAllergic1" name="txtAllergic1" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of last physical exam:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Result:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="date" id="txtDateLpe" name="txtDateLpe" className='add-only' />
                        </td>
                        <td className='w-375'>
                             &nbsp; <input type="radio" id="rbLpe_Yes" name="rbLpe" className='add-only' value="1" /> OK
                             &nbsp; <input type="radio" id="rbLpe_No" name="rbLpe" className='add-only' value="0" /> Problem:
                            <input type="text" id="txtProblem" name="txtProblem" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of last dental exam:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Result:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="date" id="txtDateLpe1" name="txtDateLpe1" className='add-only' />
                        </td>
                        <td className='w-375'>
                             &nbsp; <input type="radio" id="rbLpe1_Yes" name="rbLpe1" className='add-only' value="1" /> OK
                             &nbsp; <input type="radio" id="rbLpe1_No" name="rbLpe1" className='add-only' value="0" /> Problem:
                            <input type="text" id="txtProblem1" name="txtProblem1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of last hearing test:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Result:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="date" id="txtDateLpe2" name="txtDateLpe2" className='add-only' />
                        </td>
                        <td className='w-375'>
                             &nbsp; <input type="radio" id="rbLpe2_Yes" name="rbLpe2" className='add-only' value="1" /> OK
                             &nbsp; <input type="radio" id="rbLpe2_No" name="rbLpe2" className='add-only' value="0" /> Problem:
                            <input type="text" id="txtProblem2" name="txtProblem2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of last vision Exam:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Result:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="date" id="txtDateLpe3" name="txtDateLpe3" className='add-only' />
                        </td>
                        <td className='w-375'>
                             &nbsp; <input type="radio" id="rbLpe3_Yes" name="rbLpe3" className='add-only' value="1" /> OK
                             &nbsp; <input type="radio" id="rbLpe3_No" name="rbLpe3" className='add-only' value="0" /> Problem:
                            <input type="text" id="txtProblem3" name="txtProblem3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Pregnant:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Taking birth control:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                             &nbsp; <input type="radio" id="rbPregnant_Yes" name="rbPregnant" className='add-only' value="1" />  Yes &nbsp;
                             &nbsp; <input type="radio" id="rbPregnant_No" name="rbPregnant" className='add-only' value="0" />  No &nbsp;
                        </td>
                        <td className='w-375'>
                             &nbsp; <input type="radio" id="rbTaking_Yes" name="rbTaking" className='add-only' value="1" />  Yes &nbsp;
                             &nbsp; <input type="radio" id="rbTaking_No" name="rbTaking" className='add-only' value="0" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Miscarriage/Abortion:</span>
                        </td>
                        <td className='w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                             &nbsp; <input type="radio" id="rbMiscarriage_Yes" name="rbMiscarriage" className='add-only' value="1" />  Yes &nbsp;
                             &nbsp; <input type="radio" id="rbMiscarriage_No" name="rbMiscarriage" className='add-only' value="0" />  No &nbsp;
                        </td>
                        <td className='w-375'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h3>5. CHEMICAL USE HISTORY
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>Does the child/adolescent use or have a problem with alcohol or drugs?</span>
                     &nbsp; <input type="radio" id="rbChemical_Yes" name="rbChemical" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbChemical_No" name="rbChemical" className='add-only' value="0" />  No &nbsp;
                </p>
                <p className='w-750'>
                    If Yes,
                     &nbsp; <input type="radio" id="rbMarijuana_1" name="rbMarijuana" className='add-only' value="1" /> Methamphetamine
                     &nbsp; <input type="radio" id="rbMarijuana_0" name="rbMarijuana" className='add-only' value="0" /> Marijuana
                     &nbsp; <input type="radio" id="rbMarijuana_2" name="rbMarijuana" className='add-only' value="2" />  Alcohol
                     &nbsp; <input type="radio" id="rbMarijuana_3" name="rbMarijuana" className='add-only' value="3" /> Crack
                     &nbsp; <input type="radio" id="rbMarijuana_4" name="rbMarijuana" className='add-only' value="4" />Prescription Drugs
                     &nbsp; <input type="radio" id="rbMarijuana_5" name="rbMarijuana" className='add-only' value="5" />Cocaine
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Length of use:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency of use:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>History of use:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtLength" name="txtLength" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFrequency" name="txtFrequency" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHistory" name="txtHistory" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Does anyone in the household use illegal drugs:</span>
                     &nbsp; <input type="radio" id="rbDrugs_Yes" name="rbDrugs" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbDrugs_No" name="rbDrugs" className='add-only' value="0" />  No &nbsp;
                    Who:<input type="text" id="txtWho" name="txtWho" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Substance Abuse History Details:</span>
                    <textarea id="txtSubstanceAbuse" name="txtSubstanceAbuse" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>6. COUNSELING/PRIOR TREATMENT HISTORY</span>
                </p>
                <p className='w-750'>
                    Information about child/adolescent (past and present):<input type="text" id="txtInformation" name="txtInformation" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Counseling/Psychiatric Treatment</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Year:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Result:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                             &nbsp; <input type="radio" id="rbCounseling_Yes" name="rbCounseling" className='add-only' value="1" />  Yes &nbsp;
                             &nbsp; <input type="radio" id="rbCounseling_No" name="rbCounseling" className='add-only' value="0" />  No &nbsp;
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtYear" name="txtYear" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResult" name="txtResult" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Suicidal Thoughts/Attempts</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Year:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Result:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                             &nbsp; <input type="radio" id="rbCounseling1_Yes" name="rbCounseling1" className='add-only' value="1" />  Yes &nbsp;
                             &nbsp; <input type="radio" id="rbCounseling1_No" name="rbCounseling1" className='add-only' value="0" />  No &nbsp;
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtYear1" name="txtYear1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResult1" name="txtResult1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Drug/Alcohol treatment</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Year:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Result:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                             &nbsp; <input type="radio" id="rbCounseling2_Yes" name="rbCounseling2" className='add-only' value="1" />  Yes &nbsp;
                             &nbsp; <input type="radio" id="rbCounseling2_No" name="rbCounseling2" className='add-only' value="0" />  No &nbsp;
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtYear2" name="txtYear2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResult2" name="txtResult2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Hospitalizations</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Year:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Result:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                             &nbsp; <input type="radio" id="rbCounseling3_Yes" name="rbCounseling3" className='add-only' value="1" />  Yes &nbsp;
                             &nbsp; <input type="radio" id="rbCounseling3_No" name="rbCounseling3" className='add-only' value="0" />  No &nbsp;
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtYear3" name="txtYear3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResult3" name="txtResult3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>7. BEHAVIORAL/EMOTIONAL STATUS</span>
                </p>
                <p className='w-750'>
                    Please check any of the following that are typical for your child:
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta" id="chkEmotionalSta" className='add-only' value="Aggressive" /> Aggressive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta1" id="chkEmotionalSta1" className='add-only' value="Frustrated easily" /> Frustrated easily
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta2" id="chkEmotionalSta2" className='add-only' value="Sad" />
                            Sad
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta3" id="chkEmotionalSta3" className='add-only' value="Selfish" /> Selfish
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta4" id="chkEmotionalSta4" className='add-only' value="Alcohol issues" /> Alcohol issues
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta5" id="chkEmotionalSta5" className='add-only' value="Gambling" />
                            Gambling
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta6" id="chkEmotionalSta6" className='add-only' value="Angry" /> Angry
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta7" id="chkEmotionalSta7" className='add-only' value="Anxiety" /> Anxiety
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta8" id="chkEmotionalSta8" className='add-only' value="Hallucinations" />
                            Hallucinations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta9" id="chkEmotionalSta9" className='add-only' value="Head banging" /> Head banging
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta10" id="chkEmotionalSta10" className='add-only' value="Sets fires" /> Sets fires
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta11" id="chkEmotionalSta11" className='add-only' value="Separation anxiety" />
                            Separation anxiety
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta12" id="chkEmotionalSta12" className='add-only' value="Hurts animals" /> Hurts animals
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta13" id="chkEmotionalSta13" className='add-only' value="Sexual addiction" /> Sexual addiction
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta14" id="chkEmotionalSta14" className='add-only' value="Avoids adults" />
                            Avoids adults
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta15" id="chkEmotionalSta15" className='add-only' value="Loner" /> Loner
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta16" id="chkEmotionalSta16" className='add-only' value="Imaginary friends" /> Imaginary friends
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta17" id="chkEmotionalSta17" className='add-only' value="Sexual acting out" />
                            Sexual acting out
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta18" id="chkEmotionalSta18" className='add-only' value="Bedwetting" /> Bedwetting
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta19" id="chkEmotionalSta19" className='add-only' value="Impulsive  " /> Impulsive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta20" id="chkEmotionalSta20" className='add-only' value="Short attention span" /> Short attention span
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta21" id="chkEmotionalSta21" className='add-only' value="Bizarre behavior" /> Bizarre behavior
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta22" id="chkEmotionalSta22" className='add-only' value="Irritable" /> Irritable
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta23" id="chkEmotionalSta23" className='add-only' value="Sleeping problems" /> Sleeping problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta24" id="chkEmotionalSta24" className='add-only' value="Lazy" /> Lazy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta25" id="chkEmotionalSta25" className='add-only' value="Speech problems" /> Speech problems
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta26" id="chkEmotionalSta26" className='add-only' value="Careless reckless" /> Careless, reckless
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta27" id="chkEmotionalSta27" className='add-only' value="Bullies threatens" /> Bullies, threatens
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta28" id="chkEmotionalSta28" className='add-only' value="Learning problems" /> Learning problems
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta29" id="chkEmotionalSta29" className='add-only' value="Lies frequently" /> Lies frequently
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta30" id="chkEmotionalSta30" className='add-only' value="Steals" /> Steals
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta31" id="chkEmotionalSta31" className='add-only' value="Clumsy" /> Clumsy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta32" id="chkEmotionalSta32" className='add-only' value="Suicidal threats" /> Suicidal threats
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta33" id="chkEmotionalSta33" className='add-only' value="Low self-esteem" /> Low self-esteem
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta34" id="chkEmotionalSta34" className='add-only' value="Messy" /> Messy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta35" id="chkEmotionalSta35" className='add-only' value="Suicidal Attempts" /> Suicidal Attempts
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta36" id="chkEmotionalSta36" className='add-only' value="Talks back" /> Talks back
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta37" id="chkEmotionalSta37" className='add-only' value="Moody" /> Moody
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta38" id="chkEmotionalSta38" className='add-only' value="Tics or twitching" /> Tics or twitching
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta39" id="chkEmotionalSta39" className='add-only' value="Nightmares" /> Nightmares
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta40" id="chkEmotionalSta40" className='add-only' value="Cyber addiction" /> Cyber addiction
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta41" id="chkEmotionalSta41" className='add-only' value="Defiant" /> Defiant
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta42" id="chkEmotionalSta42" className='add-only' value="Destructive" /> Destructive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta43" id="chkEmotionalSta43" className='add-only' value="Oppositional" /> Oppositional
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta44" id="chkEmotionalSta44" className='add-only' value="Phobias" /> Phobias
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta45" id="chkEmotionalSta45" className='add-only' value="Panic attacks" /> Panic attacks
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta46" id="chkEmotionalSta46" className='add-only' value="Drugs dependence" /> Drugs dependence
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta47" id="chkEmotionalSta47" className='add-only' value="Phobias" /> Phobias
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta48" id="chkEmotionalSta48" className='add-only' value="Fearful" /> Fearful
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkEmotionalSta49" id="chkEmotionalSta49" className='add-only' value="Quarrels" /> Quarrels
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Does client engage in situations where high risk is involved?</span>
                     &nbsp; <input type="radio" id="rbEngage_Yes" name="rbEngage" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbEngage_No" name="rbEngage" className='add-only' value="0" />  No &nbsp;
                </p>
                <p className='w-750'>
                    If yes:
                     &nbsp; <input type="radio" id="rbUnprotected_1" name="rbUnprotected" className='add-only' value="1" /> Unprotected sex
                     &nbsp; <input type="radio" id="rbUnprotected_0" name="rbUnprotected" className='add-only' value="0" /> Drinking and driving
                     &nbsp; <input type="radio" id="rbUnprotected_2" name="rbUnprotected" className='add-only' value="2" />  Physica1 fights
                     &nbsp; <input type="radio" id="rbUnprotected_3" name="rbUnprotected" className='add-only' value="3" /> Shoplifting<br />
                     &nbsp; <input type="radio" id="rbUnprotected_4" name="rbUnprotected" className='add-only' value="4" />Curfew violations
                     &nbsp; <input type="radio" id="rbUnprotected_5" name="rbUnprotected" className='add-only' value="5" />Other
                    <input type="text" id="txtUnprotected" name="txtUnprotected" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Who is the disciplinarian?</span>
                     &nbsp; <input type="radio" id="rbFather_1" name="rbFather" className='add-only' value="1" /> Mother
                     &nbsp; <input type="radio" id="rbFather_0" name="rbFather" className='add-only' value="0" /> Father
                     &nbsp; <input type="radio" id="rbFather_2" name="rbFather" className='add-only' value="2" />  Guardian
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>How is discipline delivered?</span>
                    <textarea id="txtDiscipline" name="txtDiscipline" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What does the child/adolescent do with unstructured time?</span>
                    <textarea id="txtAdolescent" name="txtAdolescent" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have there been any significant changes or events in your child's life?</span>
                     &nbsp; <input type="radio" id="rbLife_Yes" name="rbLife" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbLife_No" name="rbLife" className='add-only' value="0" />  No &nbsp;
                </p>
                <p className='w-750'>
                    If yes
                     &nbsp; <input type="radio" id="rbLife_1" name="rbLife" className='add-only' value="1" /> family death
                     &nbsp; <input type="radio" id="rbLife_0" name="rbLife" className='add-only' value="0" /> moving
                     &nbsp; <input type="radio" id="rbLife_2" name="rbLife" className='add-only' value="2" />  fire
                     &nbsp; <input type="radio" id="rbLife_3" name="rbLife" className='add-only' value="3" /> change of school<br />
                     &nbsp; <input type="radio" id="rbLife_5" name="rbLife" className='add-only' value="5" />other:
                    <input type="text" id="txtLife" name="txtLife" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>8. FINANCIAL STATUS</span>
                </p>
                <p className='w-750'>
                    Family Annual Income: $<input type="text" id="txtFamilyAnnual" name="txtFamilyAnnual" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has the family been experiencing any financial difficulties in course of the last 6 months?</span>
                     &nbsp; <input type="radio" id="rbFinancial_Yes" name="rbFinancial" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbFinancial_No" name="rbFinancial" className='add-only' value="0" />  No &nbsp;
                </p>
                <p className='w-750'>
                    If yes, explain<br />
                    <textarea id="txtFinancial" name="txtFinancial" className='add-only'></textarea>
                </p>
                <h3>9. COMMUNITY RESOURCES
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>Which community resources is your family currently utilizing?</span>
                     &nbsp; <input type="radio" id="rbCommunity_1" name="rbCommunity" className='add-only' value="1" /> Church
                     &nbsp; <input type="radio" id="rbCommunity_0" name="rbCommunity" className='add-only' value="0" /> Civic Groups
                     &nbsp; <input type="radio" id="rbCommunity_2" name="rbCommunity" className='add-only' value="2" />  Social Services Agencies
                     &nbsp; <input type="radio" id="rbCommunity_3" name="rbCommunity" className='add-only' value="3" /> Community Action Authority<br />
                     &nbsp; <input type="radio" id="rbCommunity_5" name="rbCommunity" className='add-only' value="5" />Other:
                    <input type="text" id="txtCommunity" name="txtCommunity" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>10. EDUCATION</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <strong>Current school:</strong></td>
                        <td className='w-375'>
                            <strong>School phone number:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtCurrentSchool" name="txtCurrentSchool" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtPhoneNumber" name="txtPhoneNumber" className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Type of school:</span>
                     &nbsp; <input type="radio" id="rbType5_Yes" name="rbType5" className='add-only' value="1" /> Public
                     &nbsp; <input type="radio" id="rbType5_No" name="rbType5" className='add-only' value="2" />  Alternative
                     &nbsp; <input type="radio" id="rbType5_Na" name="rbType5" className='add-only' value="3" /> Home schooled
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkTruancy" id="chkTruancy" className='add-only' value="Mental Health Skill Building" />  Truancy
                    <input type="checkbox" name="chkTruancy1" id="chkTruancy1" className='add-only' value="Number of days Missed" /> Number of days Missed:
                    <input type="text" id="txtTruancy" name="txtTruancy" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <strong>Tardy:</strong></td>
                        <td className='w-375'>
                            <strong>In special education?</strong></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtTardy" name="txtTardy" className='add-only' /></td>
                        <td className='w-375'>
                             &nbsp; <input type="radio" id="rbTardy_Yes" name="rbTardy" className='add-only' value="1" />  Yes &nbsp;
                             &nbsp; <input type="radio" id="rbTardy_No" name="rbTardy" className='add-only' value="2" />  No</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Has child ever been held back in school?</span>
                     &nbsp; <input type="radio" id="rbSchool_Yes" name="rbSchool" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbSchool_No" name="rbSchool" className='add-only' value="2" />  No
                </p>
                <p className='w-750'>
                    If Yes, what grade:<textarea id="txtGrade" name="txtGrade" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have there been any recent changes in the child's grades?</span>
                     &nbsp; <input type="radio" id="rbSchool1_Yes" name="rbSchool1" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbSchool1_No" name="rbSchool1" className='add-only' value="2" />  No
                </p>
                <p className='w-750'>
                    If yes, describe:<textarea id="txtGrade1" name="txtGrade1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has the child been tested psychologically?</span>
                     &nbsp; <input type="radio" id="rbSchool11_Yes" name="rbSchool11" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbSchool11_No" name="rbSchool11" className='add-only' value="2" />  No
                </p>
                <p className='w-750'>
                    If yes, what year:<input type="text" id="txtRelationshipYear" name="txtRelationshipYear" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is there an</span>
                     &nbsp; <input type="radio" id="rbSchool12_Yes" name="rbSchool12" className='add-only' value="1" /> IEP
                     &nbsp; <input type="radio" id="rbSchool12_No" name="rbSchool12" className='add-only' value="2" />  504 Plan
                     &nbsp; <input type="radio" id="rbSchool12_Na" name="rbSchool12" className='add-only' value="3" /> SST required?
                </p>
                <p className='w-750'>
                    N/A <input type="checkbox" name="chkAdult11" id="chkAdult11" className='add-only' value="Adult" />  Adult
                </p>
                <p className='w-750'>
                    Placement History:
                    <textarea id="txtPlacement" name="txtPlacement" className='add-only'></textarea>
                </p>
                <h3>11. ADDITIONAL QUESTIONS (PRE/POST TEST)
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>1. Is the client going to school?</span>
                     &nbsp; <input type="radio" id="rbPost_Yes" name="rbPost" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbPost_No" name="rbPost" className='add-only' value="2" />  No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>2. Is the client medication compliant?</span>
                     &nbsp; <input type="radio" id="rbPost1_Yes" name="rbPost1" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbPost1_No" name="rbPost1" className='add-only' value="2" />  No
                     &nbsp; <input type="radio" id="rbPost1_Na" name="rbPost1" className='add-only' value="3" /> N/A
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>3. Is the client chemically dependent?</span>
                     &nbsp; <input type="radio" id="rbPost2_Yes" name="rbPost2" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbPost2_No" name="rbPost2" className='add-only' value="2" />  No evidence
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4. Has the client ever been arrested?</span>
                     &nbsp; <input type="radio" id="rbPost3_Yes" name="rbPost3" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbPost3_No" name="rbPost3" className='add-only' value="2" />  No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>5. Is the client presently on probation/parole?</span>
                     &nbsp; <input type="radio" id="rbPost4_Yes" name="rbPost4" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbPost4_No" name="rbPost4" className='add-only' value="2" />  No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>6. Is the client a risk to themselves?</span>
                     &nbsp; <input type="radio" id="rbPost5_Yes" name="rbPost5" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbPost5_No" name="rbPost5" className='add-only' value="2" />  No evidence
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>7. Is there a history of Trauma?</span>
                     &nbsp; <input type="radio" id="rbPost6_Yes" name="rbPost6" className='add-only' value="1" />  Yes &nbsp;
                     &nbsp; <input type="radio" id="rbPost6_No" name="rbPost6" className='add-only' value="2" />  No
                </p>
                <p className='w-750'>
                    12. <input type="checkbox" name="chkDiagnostic" id="chkDiagnostic" className='add-only' value="Adult" /> DIAGNOSTIC IMPRESSIONS/
                    <input type="checkbox" name="chkDiagnostic1" id="chkDiagnostic1" className='add-only' value="Adult" /> DIAGNOSIS:
                    <textarea id="txtDiagnostic" name="txtDiagnostic" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Axis I:</span>
                    <textarea id="txtAxis1" name="txtAxis1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Axis II:</span>
                    <textarea id="txtAxis2" name="txtAxis2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Axis III:</span>
                    <textarea id="txtAxis3" name="txtAxis3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Axis IV:</span>
                    <textarea id="txtAxis4" name="txtAxis4" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Axis V:</span>
                    <textarea id="txtAxis5" name="txtAxis5" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>NARRATIVE SUMMARY:
                    </span><span className="small">(a synopsis of the clinical interview and the assessment is to be detailed here, including information from the client/family, social and medical history, clinical inferences/judgments)</span>
                    <textarea id="txtNarravite" name="txtNarravite" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Treatment Course</span>
                    <textarea id="txtTreatment" name="txtTreatment" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    Based on the intake data and the comprehensive assessment the client meets admission criteria for IFI/CORE Services, with a start date of:
                    <input type="date" id="txtRelationshipBased" name="txtRelationshipBased" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='signature w-450'>&nbsp;</td>
                        <td className='signature w-300'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-450'>Therapist's/ST's Signature</td>
                        <td className='small w-300'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-450'>&nbsp;</td>
                        <td className='signature w-300'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-450'>Reviewed by: Supervisor's Signature:</td>
                        <td className='small w-300'>Date:</td>
                    </tr>
                </table>
                <h3>IFI/CORE (STRENGTHS, NEEDS, ABILITIES, AND PREFERENCES) FORM
                </h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Family:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Therapist/TA:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtFamily" name="txtFamily" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtTherapist" name="txtTherapist" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateFa" name="txtDateFa" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Coming in for a screening is a very important first step in your recovery process. In order for us to determine the best recommendation for you it would be very helpful for you to identify your strengths, needs, abilities and preferences as well as your goals and what you want to accomplish. Your strengths and abilities are those things about you, your life and your surroundings that help make you successful in reaching your goals. The following guidelines and samples will help you identify these items. Please feel free to fill in the blank spaces with your own ideas.
                </p>
                <h3>STRENGTHS
                </h3>
                <p className='w-750'>
                    What are some of the things about your current situation or your surroundings that will assist you in your treatment? Check those that apply and fill in at least one other.
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkStrenght" id="chkStrenght" className='add-only' value="Support from my family" /> Support from my family (parents, children, other)
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkStrenght1" id="chkStrenght1" className='add-only' value="Support from" /> Support from my spouse or significant other
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkStrenght2" id="chkStrenght2" className='add-only' value="Connection to a self" /> Connection to a self-help or advocacy group
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkStrenght3" id="chkStrenght3" className='add-only' value="A positive and supportive" /> A positive and supportive sponsor or mentor
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkStrenght4" id="chkStrenght4" className='add-only' value="Connection to a church" /> Connection to a church group or minister
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkStrenght5" id="chkStrenght5" className='add-only' value="My employer" /> My employer, who helped me get into treatment
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkStrenght6" id="chkStrenght6" className='add-only' value="A permanent place to live" /> A permanent place to live
                    Stable home environment
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkStrenght7" id="chkStrenght7" className='add-only' value="Other" /> Other
                    <input type="text" id="txtTherapistOther" name="txtTherapistOther" className='add-only' />
                </p>
                <h3>NEEDS
                </h3>
                <p className='w-750'>
                    What are some of the things you believe are necessary in order for you to be successful in completing a program? Check those that apply and fill in at least one other.
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkNeeds" id="chkNeeds" className='add-only' value="Education about mental" /> Education about mental Illness
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkNeeds1" id="chkNeeds1" className='add-only' value="An explanation of my diagnosis" /> An explanation of my diagnosis
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkNeeds2" id="chkNeeds2" className='add-only' value="Improvement in" /> Improvement in my communication skills
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkNeeds3" id="chkNeeds3" className='add-only' value="Improvement in my interpersonal" /> Improvement in my interpersonal skills\relationships
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkNeeds4" id="chkNeeds4" className='add-only' value="Connection to a self" /> Connection to a self-help or advocacy group
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkNeeds5" id="chkNeeds5" className='add-only' value="Help in managing my feelings" /> Help in managing my feelings
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkNeeds6" id="chkNeeds6" className='add-only' value="Anger management skills" /> Anger management skills
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkNeeds7" id="chkNeeds7" className='add-only' value="Education about effects" /> Education about effects of substance abuse on health
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkNeeds8" id="chkNeeds8" className='add-only' value="Education on improving" /> Education on improving my health
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkNeeds9" id="chkNeeds9" className='add-only' value="Other" /> Other:
                    <input type="text" id="txtTherapistOther1" name="txtTherapistOther1" className='add-only' />
                </p>
                <h3>ABILITIES
                </h3>
                <p className='w-750'>
                    What are some of your personal qualities, skills and talents that will assist you in your program? Check those that apply and fill in at least one other.
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities" id="chkAbilities" className='add-only' value="I can" /> I can be honest in group discussions
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities1" id="chkAbilities1" className='add-only' value="I am cooperative" /> I am cooperative
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities2" id="chkAbilities2" className='add-only' value="I am willing" /> I am willing to work to grow and change
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities3" id="chkAbilities3" className='add-only' value="I am trustworthy" /> I am trustworthy
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities4" id="chkAbilities4" className='add-only' value="I have faith in God" /> I have faith in God (higher power)
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities5" id="chkAbilities5" className='add-only' value="I have a good" /> I have a good sense of humor
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities6" id="chkAbilities6" className='add-only' value="I have determination" /> I have determination
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities7" id="chkAbilities7" className='add-only' value="I easily share my thought" /> I easily share my thoughts and feelings with others
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities8" id="chkAbilities8" className='add-only' value="I can respect another" /> I can respect another person's privacy
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities9" id="chkAbilities9" className='add-only' value="I am able to ask" /> I am able to ask for help from others
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities11" id="chkAbilities11" className='add-only' value="I can accept and act" /> I can accept and act on advice from others
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities12" id="chkAbilities12" className='add-only' value="I can accept" /> I can accept criticism from others
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities13" id="chkAbilities13" className='add-only' value="I care about my own" /> I care about my own well-being & the well-being of others
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities15" id="chkAbilities15" className='add-only' value="I am able to fulfill" /> I am able to fulfill my program obligations
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkAbilities14" id="chkAbilities14" className='add-only' value="Other" /> Other:
                    <input type="text" id="txtTherapistOther3" name="txtTherapistOther3" className='add-only' />
                </p>
                <h3>PREFERENCES
                </h3>
                <p className='w-750'>
                    What are some of your preferences when considering a treatment program?
                </p>
                <p className='w-750'>
                    Which of the following activities would you most like to attend?
                    Check all the apply
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkPreferences" id="chkPreferences" className='add-only' value="Group therapy" /> Group therapy
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkPreferences1" id="chkPreferences1" className='add-only' value="Education classes" /> Education classes
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkPreferences2" id="chkPreferences2" className='add-only' value="Individual therapy" /> Individual therapy sessions
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkPreferences3" id="chkPreferences3" className='add-only' value="Family Education" /> Family Education and Support
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkPreferences4" id="chkPreferences4" className='add-only' value="Couples counseling" /> Couples counseling
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkPreferences5" id="chkPreferences5" className='add-only' value="AA" /> AA, NA or Al-anon
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkPreferences6" id="chkPreferences6" className='add-only' value="Mental health counseling" /> Mental health counseling
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkPreferences7" id="chkPreferences7" className='add-only' value="Community Supports" /> Community Supports/Case Management Services
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are some issues specific in your life that you wish to address while in treatment?</span>
                </p>
                <p className='w-750'>
                    1.<textarea id="txtPreferences2" name="txtPreferences2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    2.<textarea id="txtPreferences1" name="txtPreferences1" className='add-only'></textarea>
                </p>
                <h3>DESIRED OUTCOMES
                </h3>
                <p className='w-750'>
                    What are the expectations you have about coming here today? In other words, what would you like to accomplish?
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkOutcomes1" id="chkOutcomes1" className='add-only' value="I will learn" /> I will learn skills to manage my symptoms
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkOutcomes2" id="chkOutcomes2" className='add-only' value="I will understand" />
                    I will understand why I need to take my medication
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkOutcomes3" id="chkOutcomes3" className='add-only' value="I will be able to communicat" />
                    I will be able to communicate more effectively
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkOutcomes4" id="chkOutcomes4" className='add-only' value="My interpersonal" />
                    My interpersonal skills/relationships will improve
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkOutcomes5" id="chkOutcomes5" className='add-only' value="I will develop" />
                    I will develop a system of support and recovery
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkOutcomes6" id="chkOutcomes6" className='add-only' value="I will be able to " />
                    I will be able to manage my feelings
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkOutcomes7" id="chkOutcomes7" className='add-only' value="I will be able to manage my anger" />
                    I will be able to manage my anger
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkOutcomes8" id="chkOutcomes8" className='add-only' value="My health will improve" /> My health will improve
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkOutcomes9" id="chkOutcomes9" className='add-only' value="I will have an understanding" /> I will have an understanding of relapse prevention
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="chkOutcomes11" id="chkOutcomes11" className='add-only' value="Other" /> Other
                    <input type="text" id="txtTherapistOther31" name="txtTherapistOther31" className='add-only' />
                </p>
                <p className='w-750'>
                    This form was filled in by the participant and reviewed with a clinical team member. The form was completed to the best of the participants' ability. This form will be used in development of the participants' personal achievement agenda (Treatment Plan).
                </p>





            </div>
        </form>

    )
} 
